var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #717402;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(-266 733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(266 -733)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-video",
    "data-name": "Icon feather-video",
    transform: "translate(274.5 -690.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-2",
    d: "M81.986,2a7.834,7.834,0,0,1,7.833,7.834V93.621A7.834,7.834,0,0,1,77.432,100L18.781,58.1a7.834,7.834,0,0,1,0-12.75L77.432,3.459A7.83,7.83,0,0,1,81.986,2ZM74.151,78.4V25.057L36.812,51.728Z",
    transform: "translate(101.681 6.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-2",
    d: "M17.592-1h92.166a24.619,24.619,0,0,1,24.592,24.592v83.787a24.619,24.619,0,0,1-24.592,24.592H17.592A24.619,24.619,0,0,1-7,107.379V23.592A24.619,24.619,0,0,1,17.592-1Zm92.166,117.3a8.933,8.933,0,0,0,8.923-8.923V23.592a8.933,8.933,0,0,0-8.923-8.923H17.592a8.933,8.933,0,0,0-8.923,8.923v83.787a8.933,8.933,0,0,0,8.923,8.923Z",
    transform: "translate(-1.5 -7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9a8b70034947cb5fe721b6125654ef82.svg";
export { ForwardRef as ReactComponent };